import {
  createFileRoute,
  Link,
  Outlet,
  useChildMatches,
  useNavigate,
} from '@tanstack/react-router';

import { SourcePage } from '../../pages/sources';
import { useSession } from '../../entities/session';

export const Route = createFileRoute('/_shell/sources/$sourceId')({
  component: function SourceRoute() {
    const { sourceId } = Route.useParams();
    const navigate = useNavigate();
    const session = useSession();
    // `/sources/:id/clients` is a child of this path: without this the source card renders in its place.
    const children = useChildMatches();

    if (children.length > 0) return <Outlet />;

    return (
      <SourcePage
        sourceId={sourceId}
        timeZone={session.data?.preferences.timezone}
        breadcrumb={<Link to="/sources">Sources</Link>}
        onClients={() =>
          void navigate({
            to: '/sources/$sourceId/clients',
            params: { sourceId },
            search: { q: undefined },
          })
        }
        onWatch={(requestId) => void navigate({ to: '/events', search: { requestId } })}
      />
    );
  },
});
